<template>
  <div class="grid gap-4 my-4" :class="classes" v-if="block.data?.posts?.length">
    <AtomBlockHeader v-if="block.data?.title || block.data?.excerpt"
      :heading="block.data?.title"
      :leading="block.data?.excerpt"
    />
    <div class="posts" v-if="block.data?.posts?.length" v-auto-animate>
      <div class="posts__item" v-for="post in block.data?.posts" :key="post.id" :class="{ 'one-up': count === 1, 'two-up': count === 2, 'three-up': count === 3 }">
        <NuxtLink :to="post.path" class="block">
          <PostsCard :post="post" />
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  block: Object
})

const classes = [
    props.block.data?.align === 'left' ? 'max-w-3xl' : null, 
    props.block.data?.align === 'center' ? 'w-full max-w-3xl mx-auto' : null,
  ].filter(str => str).join(' ')

const count = computed(() => props.block.data?.posts?.length)
</script>

<style lang="scss" scoped>
// Grid
.posts {
  @apply grid grid-cols-12 gap-x-4 gap-y-8 md:gap-8;

  &__item {
    @apply col-span-6 md:col-span-4 lg:md:col-span-3;

    &.one-up {
      @apply col-span-full;
    }

    &.two-up {
      @apply col-span-full md:col-span-6 lg:md:col-span-6;
    }

    &.three-up {
      @apply col-span-full md:col-span-4;
    }
  }
}
</style>